import {
    readLocalStorage,
    removeLocalStorageItem,
    writeLocalStorage,
} from '../../../util/localStorage';

import type {ReportId} from '../report-types';

const PROMPT_KEY = 'ai-report-prompt';

export function getBannerInfo(savedFilterId: ReportId) {
    const bannerInfo = readLocalStorage(savedFilterId);

    if (!bannerInfo) {
        return null;
    }

    try {
        return JSON.parse(bannerInfo);
    } catch (_error: any) {
        return null;
    }
}

export function writeBannerInfo(savedFilterId: ReportId, bannerInfo: any) {
    writeLocalStorage(savedFilterId, JSON.stringify(bannerInfo));
}

export function removeBannerInfo(savedFilterId: ReportId) {
    removeLocalStorageItem(savedFilterId);
}

export function writePrompt(prompt: string) {
    writeLocalStorage(PROMPT_KEY, prompt);
}

export function readPrompt() {
    const prompt = readLocalStorage(PROMPT_KEY);

    return prompt || '';
}

export function removePrompt() {
    removeLocalStorageItem(PROMPT_KEY);
}
